module.exports = __webpack_public_path__ + "resource/img/forgotpassword.306654cc.jpg";